import $ from 'jquery'
import { setupPhotoGalleries } from './_photo-gallery'
import { createRevealWithCloseButtonPortal } from './_revealCloseButtonPortal'
import { destroyVideos, setupVideos } from './_video'

const $body = $(document.body)

function replaceLazyContent(modal) {
  const lazies = modal.querySelectorAll('.lazy-content')
  lazies.forEach((lazyEl) => {
    const { html } = lazyEl.dataset
    if (!html) return

    const fragment = document.createRange().createContextualFragment(html)
    lazyEl.replaceWith(fragment)
  })
}

function setupModal(modal, options = {}) {
  const $modal = $(modal)
  if (!modal || !$modal.length) {
    return null
  }

  if ($modal.data('zfPlugin')) {
    return $modal.data('zfPlugin')
  }

  $modal
    .off('open.zf.reveal')
    .off('closed.zf.reveal')
    .on('open.zf.reveal', () => {
      replaceLazyContent($modal[0])
      setupPhotoGalleries($modal[0])
      document.dispatchEvent(
        new CustomEvent('photo-gallery:refresh-layouts', {
          detail: {
            container: $modal[0],
          },
        }),
      )
      setupVideos($modal[0], true, true)
      $body.addClass('blurred')
      $modal[0].style.setProperty('--v-offset', $modal[0].style.top)
    })
    .on('closed.zf.reveal', () => {
      destroyVideos($modal)
      $body.removeClass('blurred')
    })

  return createRevealWithCloseButtonPortal($modal, {
    vOffset: $modal.data('v-offset') ?? 60,
    ...options,
  })
}

function setupModals(container) {
  $(container)
    .find('a[href^="#modal-"]')
    .each((idx, anchor) => {
      const $anchor = $(anchor)
      const $modal = $($anchor.attr('href'))

      $anchor.on('click', (ev) => {
        ev.preventDefault()
        // ev.stopPropagation() // DO NOT UNCOMMENT. Some scripts may rely on this behavior
      })

      const modal = setupModal($modal)
      if (modal) {
        $anchor.on('click', () => {
          modal.open()
        })
      }
    })
}

function destroyModals(container) {
  const promises = []

  $(container)
    .find('a[href^="#modal-"]')
    .each((idx, anchor) => {
      const $anchor = $(anchor)
      const $modal = $($anchor.attr('href'))

      if (!$modal.length) {
        return
      }

      promises.push(
        new Promise((resolve) => {
          if ($modal.data('zfPlugin')) {
            $modal.on('closed.zf.reveal', () => {
              $modal.foundation('destroy')
              $modal.remove()
              resolve()
            })
            $modal.trigger('closed.zf.reveal')
          } else {
            resolve()
          }
        }),
      )
    })

  return promises
}

export { setupModal, setupModals, destroyModals }
